module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"connection":"Connection","authentication_failed":"Authentication failed"},"fr":{"connection":"Connexion","authentication_failed":"Impossible de vous authentifier"}}')
  delete Component.options._Ctor
}
